import PageTitle from "@/design/components/PageTitle";

import { Box, List } from "@mui/material";
import PropTypes from "prop-types";

function MasterList({ title, fabBar = false, children, ...props }) {
  return (
    <Box
      sx={{
        pb: fabBar ? 8.5 : 0,
        pt: 8,
        height: "100dvh",
        overflow: "auto",
      }}
    >
      {title && <PageTitle>{title}</PageTitle>}
      <List
        component="nav"
        sx={(theme) => ({
          ...theme.scrollbar,
          "& .MuiListItem-root": {
            minHeight: (theme) => theme.spacing(6),
          },
          "& .MuiListItemButton-root": {
            minHeight: (theme) => theme.spacing(6),
          },
        })}
        {...props}
      >
        {children}
      </List>
    </Box>
  );
}

MasterList.propTypes = {
  title: PropTypes.string,
  fabBar: PropTypes.bool,
  children: PropTypes.node,
};

export default MasterList;
